<template>
  <div
    class="justify-center w-full h-full d-flex align-center login-hero"
    style="background: white"
  >
    <r-img
      style="z-index: 3"
      alt="Company Logo"
      :class="{
        'login-logo': $vuetify.display.mdAndUp,
        'login-logo-mobile': $vuetify.display.smAndDown,
      }"
      :src="logo"
      width="140"
      cover
    />

    <v-card
      style="z-index: 2"
      class="pa-4"
      elevation="0"
    >
      <v-card-text class="d-flex flex-column align-center registration-container content">
        <div class="mt-4 text-center">
          <h1 class="text-h4 text-black font-weight-black mb-4">
            {{ $t('auth.token-signup.title') }}
          </h1>
          <p class="mb-8 text-body-2 text-black">
            {{ $t('auth.token-signup.description') }}
          </p>
        </div>
        <div
          class="mt-4"
          :style="{ width: $vuetify.display.smAndDown ? '100%' : '450px' }"
        >
          <v-form
            ref="signupForm"
            name="token-signup"
            @submit="submitToken"
          >
            <v-text-field
              v-model="token"
              :label="$t('auth.token-signup.form.api-key-label')"
              variant="outlined"
              hide-details="auto"
              class="mb-4"
              :rules="[rules.required]"
              required
              validate-on="blur"
            />

            <div class="px-0 d-flex flex-column">
              <v-expand-transition>
                <v-alert
                  v-if="error"
                  type="error"
                  density="compact"
                  tile
                  text
                  class="my-4"
                >
                  <span v-html="getErrorMessage(error)" />
                </v-alert>
              </v-expand-transition>
              <loading-button
                color="primary"
                type="submit"
                class="mb-5"
                :loading="submitting"
                :disabled="!token"
              >
                {{ $t('auth.token-signup.form.submit-button') }}
              </loading-button>
            </div>
          </v-form>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import logo from '@/assets/img/logo.png'
import LoadingButton from '@/components/loading-button.vue'
import { required } from '@/lib/validation'
import brandingMixin from '@/mixins/branding'
import featureMixin from '@/mixins/feature'

import VALIDATE_SIGNUP_TOKEN from './ValidateSignUpToken.gql'

export default {
  components: {
    LoadingButton,
  },
  mixins: [featureMixin, brandingMixin],
  props: {
    partner: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      submitting: false,
      token: '',
      error: null,
      logo,
    }
  },
  computed: {
    errorMessages() {
      return {
        invalidToken: this.$t('auth.token-signup.errors.invalid-token'),
        unknown: this.$t('auth.token-signup.errors.unknown'),
      }
    },
  },
  created() {
    this.rules = { required }
  },
  mounted() {
    this.token = this.$route.params.token
    if (this.token) this.submitToken()
  },
  apollo: {
    $client: 'public',
  },
  methods: {
    async submitToken(event) {
      if (event) event.preventDefault()
      this.error = null

      this.submitting = true

      try {
        const {
          data: { validateSignUpToken: token },
        } = await this.$apollo.mutate({
          mutation: VALIDATE_SIGNUP_TOKEN,
          context: { withoutAuth: true },
          variables: {
            input: {
              token: this.token,
              partner: this.partner,
            },
          },
        })

        this.submitting = false
        this.$router.push({ name: 'signup', params: { token } })
      } catch (error) {
        if (error?.message?.match(/Invalid token/)) {
          this.error = 'invalidToken'
        } else {
          this.error = 'unknown'
        }
        this.submitting = false
      }
    },
    getErrorMessage(code) {
      return this.errorMessages[code] || this.errorMessages.unknown
    },
  },
}
</script>

<style scoped>
.content {
  width: 100%;
  max-width: 450px;
}

.login-hero {
  position: relative;
  height: 100%;
}

.login-logo {
  position: absolute;
  top: 0;
  left: 0;
  margin-top: 30px;
  margin-left: 30px;
  z-index: 2;
}

.login-logo-mobile {
  position: absolute;
  top: 0;
  margin-top: 30px;
  left: auto;
  right: auto;
  z-index: 2;
}
</style>
